<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import api from '@/api';
import BoxFolderCreateForm from '@/components/admin/user-documents/box-folder-create-form.vue';
import { useSnackbar } from '@/components/common/snackbar/use-snackbar';
import Header from '@/components/layouts/header.vue';
import { BoxFolder } from '@/types';

const initBoxFolders = ref<BoxFolder[]>([]);

/**
 * 以下の条件で使用するAPIが異なる
 * - 初回認証の場合はBOXフォルダ情報を登録する
 * - 初回認証でない場合は、BOXフォルダ情報を更新する
 */
const firstAuthorization = ref(true);

const { createSnackbar } = useSnackbar();
const router = useRouter();
const isSubmitting = ref(false);
const submit = async (folders: BoxFolder[]) => {
  try {
    isSubmitting.value = true;
    if (firstAuthorization.value) {
      await api.postBoxFolders(folders);
    } else {
      await api.putBoxFolders(folders);
    }
  } catch {
    createSnackbar({
      message: 'BOXフォルダの登録に失敗しました',
      type: 'error',
    });
    return;
  } finally {
    isSubmitting.value = false;
  }
  await router.push({
    name: 'boxIndex',
    query: { from: 'box_folder_create' },
  });
};

onMounted(async () => {
  try {
    initBoxFolders.value = await api.getBoxFolders(false);
    firstAuthorization.value = initBoxFolders.value.length === 0;
  } catch {
    createSnackbar({
      message: 'BOXフォルダの取得に失敗しました',
      type: 'error',
    });
  }
});
</script>

<template>
  <div class="box-folder-create">
    <Header title="BOXを認証" header-width="100%" is-one-line />
    <BoxFolderCreateForm
      @submit="submit"
      :init-box-folders="initBoxFolders"
      :is-submitting="isSubmitting"
    />
  </div>
</template>

<style lang="scss" scoped>
.box-folder-create {
  width: 100%;
  padding: 0 !important;
}
</style>
